<template>
	<div id="fp">

	</div>
</template>

<script>
    export default {
        name: 'reportDetail',
        data () {
            return {
                options: {
                    menu: '#menu',
                    sectionsColor: ['#41b883', '#ff5f45', '#0798ec'],
                    controlArrows: false,
                },
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	#fp {
		top: 0;
		left: 0;
		width: 100vw;
		height: 100vh;
		position: fixed;
		z-index: 9999;
		background: linear-gradient(to right, rgb(15, 32, 39), rgb(32, 58, 67), rgb(44, 83, 100));
	}
	.aveox {
		height: 400px;
	}
	.aveo {
		height: 1200px;
	}
</style>



// WEBPACK FOOTER //
// src/components/reports/detail.vue